// receive price_cents and return price
const Price = (price_cents) => {
  return price_cents / 100;
};

export default Price;
